import { DownloadOutlined } from "@ant-design/icons";
import { Tooltip, Button } from "antd";
import React, { useRef, useState } from "react";
import { useRestApi } from "~/hooks";
import { useTaxonomyLabel } from "~/context/taxonomy-context";
export const MatterTemplateDownloadButton: React.FC<{ templateId: number }> = ({ templateId }) => {
  const restApi = useRestApi();
  const [downloading, setDownloading] = useState(false);
  const downloadRef = useRef<HTMLAnchorElement>();

  const taxonomy = useTaxonomyLabel();

  const onDownloadTemplate = async (templateId: number) => {
    try {
      const fileDownloader = await restApi.getTemplate(templateId);
      if (downloadRef.current) {
        await fileDownloader.download(downloadRef.current);
      }
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <Tooltip title={`Download ${taxonomy.Template}`}>
        <Button
          loading={downloading}
          type="primary"
          onClick={() => onDownloadTemplate(templateId)}
          icon={<DownloadOutlined />}
        ></Button>
      </Tooltip>
      <a ref={(e) => (downloadRef.current = e || undefined)} />
    </>
  );
};
